export const IdleTimeOut = 20 * 60 * 1000 //in milliseconds (20 mins)